var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmiMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 61,
    viewBox: "0 0 46 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1186 22.4439C45.1186 38.7037 22.68 60.001 22.68 60.001C22.68 60.001 0.539062 38.1944 0.539062 22.4439C0.607887 16.5776 2.98656 10.9749 7.15923 6.85085C11.3319 2.72686 16.9621 0.414062 22.8288 0.414063C28.6956 0.414062 34.3258 2.72686 38.4985 6.85085C42.6711 10.9749 45.0498 16.5776 45.1186 22.4439Z",
    fill: "#FF9847"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmiMarker);
export default __webpack_public_path__ + "static/media/amiMarker.45584463bd7e70e31feb2aa6dac6c1be.svg";
export { ForwardRef as ReactComponent };